import React, { useState, useEffect, useRef } from 'react';

import { Row, Form, Spinner } from 'react-bootstrap';

import { getAssignments, getDrivers } from '../../features/ExpenseEntry/DriverSolutions/operations';
import { ensureSelectedOption } from '../../utils/utilities';

import Select from 'react-select';
import './styles.scoped.css';
import { useSelector, useDispatch } from 'react-redux';

import {
  setDriversAssignmentsData,
  setReceiptDataLoading,
  setReceiptData,
  setReceiptsInitialData,
} from './expenseFormSlice';
//usar set receiptData

const DriverAssignmentsForm = ({
  setReceiptField,
  setReceiptFields,
  sharedReceiptErrors,
  receipt,
  id,
  billedOrTransmitted,
  customerId,
  setForm,
}) => {
  const [isLoadingDrivers, setIsLoadingDrivers] = useState(false);
  const [isLoadingAssignments, setIsLoadingAssignments] = useState(false);
  const { driversAssignmentsData, receiptDataLoading, receiptsData, receiptsInitialData, form } = useSelector(
    state => state.expenseForm,
  );
  const dispatch = useDispatch();
  const assignmentOptionsChanged = useRef(false);

  const getDriversToSelect = async query => {
    try {
      return await getDrivers(query);
    } catch (error) {
      console.log('error: ', error);
      setIsLoadingDrivers(false);
    }
  };

  const getAssignmentsToSelect = async query => {
    try {
      return await getAssignments(query);
    } catch (error) {
      console.log('error: ', error);
      setIsLoadingAssignments(false);
    }
  };

  const handleGetData = async () => {
    if (!driversAssignmentsData?.[id]?.hasSetInitialData && !billedOrTransmitted && !receiptDataLoading && form?.lob) {
      dispatch(setReceiptDataLoading(true));
      setIsLoadingDrivers(true);
      setIsLoadingAssignments(true);

      const drivers = await getDriversToSelect(getDriversQuery());
      const assignments = await getAssignmentsToSelect(getAssignmentsQuery());

      setIsLoadingDrivers(false);
      setIsLoadingAssignments(false);

      const newData = {
        assignments: assignments,
        drivers: drivers,
        hasSetInitialData: true,
      };

      dispatch(setReceiptsInitialData(newData));

      dispatch(setDriversAssignmentsData({ id: id, data: { ...newData } }));
      dispatch(setReceiptDataLoading(false));
    }
  };

  //ASSIGNMENT CHANGE FLOW

  useEffect(() => {
    handleAssignmentFlow();
  }, [receipt?.hotelAssignmentId]);

  const getDriversQuery = () =>
    receipt?.hotelAssignmentId ? `?assignmentId=${receipt?.hotelAssignmentId}` : undefined;

  const handleAssignmentFlow = async () => {
    if (
      !receiptDataLoading &&
      receipt?.hotelAssignmentId !== receiptsData?.[id]?.hotelAssignmentId &&
      !billedOrTransmitted
    ) {
      //call get drivers when assignment
      dispatch(setReceiptDataLoading(true));
      setIsLoadingDrivers(true);
      dispatch(
        setReceiptData({
          id: id,
          data: {
            ...receiptsData[id],
            hotelAssignmentId: receipt.hotelAssignmentId,
          },
        }),
      );

      const drivers = await getDriversToSelect(getDriversQuery());

      const newData = {
        drivers: drivers,
      };
      dispatch(
        setDriversAssignmentsData({
          id: id,
          data: { ...driversAssignmentsData[id], ...newData },
        }),
      );
      setIsLoadingDrivers(false);
      dispatch(setReceiptDataLoading(false));
    }
  };

  //DRIVER CHANGE FLOW

  useEffect(() => {
    if (!billedOrTransmitted) {
      handleDriverFlow();
    }
  }, [receipt?.hotelDriverId]);

  const getAssignmentsQuery = () => {
    let query;
    if (receipt?.hotelDriverId && customerId) {
      query = `?driverId=${receipt?.hotelDriverId}&clientId=${customerId}`;
    } else if (receipt?.hotelDriverId) {
      query = `?driverId=${receipt?.hotelDriverId}`;
    } else if (customerId) {
      query = `?clientId=${customerId}`;
    }
    return query;
  };

  const handleDriverFlow = async () => {
    if (!receiptDataLoading && receipt?.hotelDriverId !== receiptsData[id]?.hotelDriverId) {
      //call get drivers when assignment
      setIsLoadingAssignments(true);
      dispatch(setReceiptDataLoading(true));
      dispatch(
        setReceiptData({
          id: id,
          data: {
            ...receiptsData[id],
            hotelDriverId: receipt.hotelDriverId,
          },
        }),
      );
      const assignments = await getAssignmentsToSelect(getAssignmentsQuery());

      const newData = {
        assignments: assignments,
      };
      dispatch(
        setDriversAssignmentsData({
          id: id,
          data: { ...driversAssignmentsData[id], ...newData },
        }),
      );
      assignmentOptionsChanged.current = true;
      setIsLoadingAssignments(false);
      dispatch(setReceiptDataLoading(false));
    }
  };

  //Get initial data

  const getReceiptData = async () => {
    if (!receiptsInitialData?.length) {
      await handleGetData();
    }
  };

  useEffect(() => {
    getReceiptData();
  }, []);

  // CP-813: keep the saved per-line driver visible on Edit when it is no longer active in EDGE
  const driverOptions = ensureSelectedOption(
    (
      (driversAssignmentsData?.[id]?.drivers ? driversAssignmentsData?.[id]?.drivers : receiptsInitialData?.drivers) || []
    ).map(({ APPL_FIRSTNAME, APPL_LASTNAME, APPL_ID }) => ({
      label: `${APPL_FIRSTNAME} ${APPL_LASTNAME} - ${APPL_ID}`,
      value: APPL_ID,
    })),
    receipt?.hotelDriverId,
    `${receipt?.hotelDriverName} - ${receipt?.hotelDriverId}`,
  );

  // CP-813: keep the saved per-line contract activity visible on Edit when it is no longer open in EDGE
  const assignmentsOptions = ensureSelectedOption(
    (
      (driversAssignmentsData?.[id] ? driversAssignmentsData?.[id]?.assignments : receiptsInitialData?.assignments) || []
    ).map(({ ASS_ID }) => ({
      label: ASS_ID,
      value: ASS_ID,
    })),
    receipt?.hotelAssignmentId,
    receipt?.hotelAssignmentId,
  );

  const customStyles = width => ({
    control: (provided, state) => ({
      ...provided,
      width: width,
      height: '30px',
    }),
    menuList: (provided, state) => ({
      ...provided,
      maxHeight: '200px',
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 100000,
    }),
  });

  return (
    <Row
      className="top-row"
      style={{
        margin: '5px 0 0 0',
      }}
    >
      <div
        className="top-col"
        style={{
          width: '40%',
        }}
      >
        <div className="below-container">
          <div
            className="below-container"
            style={{
              justifyContent: 'flex-start',
              width: '300px',
            }}
          >
            <Form.Group controlId="driverNameNumber">
              <Form.Label style={{ marginTop: '15px' }}>
                <div className="required"> Driver Name & Driver Number</div>
              </Form.Label>
              <div className="dropdown-spinner-container">
                <Select
                  isDisabled={receiptDataLoading}
                  defaultInputValue={receipt?.selectedDriver}
                  styles={customStyles('385px')}
                  options={driverOptions}
                  isClearable
                  onChange={(event, action) => {
                    if (action.action === 'clear') {
                      setReceiptFields(id, [
                        {
                          fieldName: 'hotelDriverId',
                          fieldValue: '',
                        },
                        {
                          fieldName: 'hotelDriverName',
                          fieldValue: '',
                        },
                        {
                          fieldName: 'selectedDriver',
                          fieldValue: '',
                        },
                      ]);
                    }
                    if (action.action === 'select-option') {
                      setReceiptFields(id, [
                        {
                          fieldName: 'hotelDriverId',
                          fieldValue: event.value,
                        },
                        {
                          fieldName: 'hotelDriverName',
                          fieldValue: event.label.split(' -').shift(),
                        },
                        {
                          fieldName: 'selectedDriver',
                          fieldValue: event.label,
                        },
                      ]);
                    }
                  }}
                  value={driverOptions?.filter(option => option.value === receipt?.hotelDriverId)}
                />
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  aria-hidden="true"
                  className="dropdown-spinner"
                  hidden={!isLoadingDrivers}
                />
              </div>
              {sharedReceiptErrors[id]?.hotelDriverId && (
                <div className="error">{sharedReceiptErrors[id]?.hotelDriverId}</div>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
      <div className="top-col">
        <Form.Group controlId="assignmentId">
          <Form.Label style={{ marginTop: '15px' }}>
            <div className="required"> Assignment / Contract Activity</div>
          </Form.Label>
          <div className="dropdown-spinner-container">
            <Select
              isDisabled={receiptDataLoading}
              isClearable
              onChange={(event, action) => {
                if (action.action === 'clear') setReceiptField(id, 'hotelAssignmentId', '');
                if (action.action === 'select-option') {
                  setReceiptField(id, 'hotelAssignmentId', event.value);
                  console.log('event', event.assignment_LineOfBusiness);
                }
              }}
              value={assignmentsOptions?.filter(option => option.value === receipt?.hotelAssignmentId)}
              styles={customStyles('225px')}
              defaultInputValue={receipt?.hotelAssignmentId}
              options={assignmentsOptions}
            />
            <Spinner
              as="span"
              animation="border"
              size="sm"
              aria-hidden="true"
              className="dropdown-spinner"
              hidden={!isLoadingAssignments}
            />
          </div>
          {sharedReceiptErrors[id]?.hotelAssignmentId && (
            <div className="error">{sharedReceiptErrors[id]?.hotelAssignmentId}</div>
          )}
        </Form.Group>
      </div>
    </Row>
  );
};

export default DriverAssignmentsForm;
